<template>
  <reports-survey template-id="ViolenceSurvey" />
</template>
<script>
import ReportsSurvey from "./ReportsSurvey";
import { mapGetters } from "vuex";
export default {
  name: "ReportsViolenceSurvey",
  components: { ReportsSurvey },
  computed: {
    ...mapGetters(["getCurrentSnapshot"]),
  },
  watch: {
    getCurrentSnapshot: {
      deep: true,
      handler() {
        this.checkAccess();
      },
    },
  },
  created() {
    this.checkAccess();
  },
  methods: {
    checkAccess() {
      if (!this.getCurrentSnapshot.surveyViolenceStatus) {
        this.$router.push("/home");
      }
    },
  },
};
</script>
